import React from "react";
import { Modal, Button } from "react-bootstrap";

const _props = {
  buttons: {
    ok: { disabled: false, label: "", onClick: (e) => {} },
    cancel: {
      disabled: false,
      label: "",
      onClick: (e) => {},
    },
  },
  show: false,
  // setShow: () => { },
  title: "",
  children: <></>,
  hideHeader: false,
  hideFooter: false,
  className: "",
  size: "lg",
};

function SlbPopUp(props = _props) {
  return (
    <Modal
      dialogClassName={props.className}
      size={props.size || "lg"}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      show={props.show}
      className="rc_popup"
    >
      {props.hideHeader === true ? null : (
        <Modal.Header closeButton={props.headerClose?.show} onHide={(event)=>props.headerClose?.onClick(event)}> 
          <Modal.Title id="contained-modal-title-vcenter">
            {props.title}
          </Modal.Title>
        </Modal.Header>
      )}
      <Modal.Body>{props.children}</Modal.Body>
      {props.hideFooter === true ? null : (
        <Modal.Footer>
          <>
            {props.buttons &&
              props.buttons.cancel &&
              props.buttons.cancel.label && (
                <Button
                  type="button"
                  disabled={props.buttons.cancel.disabled}
                  className="cancel_btn"
                  onClick={(event) => props.buttons.cancel.onClick(event)}
                >
                  {props.buttons.cancel.label}
                </Button>
              )}
            {props.buttons && props.buttons.ok && props.buttons.ok.label && (
              <Button
                type="button"
                disabled={props.buttons.ok.disabled}
                onClick={(event) => props.buttons.ok.onClick(event)}
              >
                {props.buttons.ok.label}
              </Button>
            )}
          </>
        </Modal.Footer>
      )}
    </Modal>
  );
}
export default SlbPopUp;
